import { Component, OnInit } from '@angular/core';
import {DiamondPayDataService} from "../diamond-pay-data-service.service";
import {ActivatedRoute, Router} from "@angular/router";
import { Response } from '@angular/http';

@Component({
  selector: 'app-unmatched-transaction-detail',
  templateUrl: './unmatched-transaction-detail.component.html',
  styleUrls: ['./unmatched-transaction-detail.component.css'],
  providers: [DiamondPayDataService]
})
export class UnmatchedTransactionDetailComponent implements OnInit {

  private transaction:          any;
  private routeSubscription:    any;
  private properties:           any[]   = [];
  private isEditing:            boolean = false;
  private isAttemptingMatch:    boolean = false;
  private student_id:           string;
  private isArchiving:          boolean = false;
  private updatedTransactionData = {};

  constructor(private dataService:  DiamondPayDataService,
              private route:        ActivatedRoute,
              private router:       Router) { }

  ngOnInit() {
    this.routeSubscription = this.route.params.subscribe(params => { this.initialize(params['id']); });
  }

  beginEditing() {
      this.isEditing = true;
      this.updatedTransactionData = {
                                        studentId: this.transaction.student_id
                                    };
  }

  endEditing() {
      this.isEditing = false;
  }

  attemptMatch(transaction) {
      this.isAttemptingMatch = true;
      this.dataService.attemptToMatchUnmatchedTransaction(transaction)
          .subscribe((result) => this.handleAttemptedMatchResult(result));
  }

  archiveTransaction(transaction) {
      this.isArchiving = true;
      this.dataService.archiveTransaction(transaction)
          .subscribe((result) => {
            this.isArchiving = false;
            this.router.navigateByUrl('/app/diamond-pay/unmatched-transactions');
          });
  }

  save(transaction) {
      this.student_id = transaction.student_id;
      this.dataService.saveUnmatchedTransaction(transaction)
          .subscribe((response: Response) => this.initialize(transaction.id));
  }

  initialize(transaction_id) {
      this.student_id = null;
      this.dataService
            .retrieveUnmatchedTransaction(transaction_id)
            .subscribe((response:any[]) => this.initializeFromServer(response), error => console.log(error));
  }

  initializeFromServer(response) {
      this.isEditing    = false;
      this.transaction  = response;
      this.student_id   = this.transaction.student_id;
      for (let property in this.transaction.raw_data) {
          if (property == 'controller' || property == 'action') continue;
          this.properties.push({
                                    key:    property,
                                    value:  this.transaction.raw_data[property]
                               });
      }
  }

    private handleAttemptedMatchResult(result) {
        this.isAttemptingMatch = false;
        if (result.status !== "success") {
            alert('The system was unable to find a matching disbursement.');
        } else {
            this.router.navigateByUrl('/app/diamond-pay/unmatched-transactions');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/unmatched-transaction-detail/unmatched-transaction-detail.component.ts